/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { JBP_AUDIT_FRAGMENT } from '../fragments/JBPAuditFragment'

export const GET_JBP_AUDITS = gql`
  query GetJBPAudits($input: JBPAuditsInput!) {
    JBPAudits(input: $input) {
      count
      hasMore
      results {
        ...JBPAudit
      }
    }
  }
  ${JBP_AUDIT_FRAGMENT}
`
